<script setup>
import { setPageTitle } from '@/@core/utils/pageMetaUtils'

setPageTitle(PageMeta.Quotes.service.title)
definePage({ meta: PageMeta.Quotes.service.meta })
import { Subject } from '@/@vxapp/@Enums/PHP/Auth/Ability/Subjects/DataProviders/AbilitySubject'
import { ServiceType } from '@/@vxapp/@Enums/ServiceType'
import QuotesServicePage from '@/views/Previews/Quotes/QuotesServicePage.vue'

/* ** */
</script>

<template>
  <div
    class="preview-service-wrapper"
    data-testid="service-page-root"
    :data-service-type="ServiceType.Quotes.Name"
  >
    <QuotesServicePage :source-subject="Subject.QUOTES_PREVIEW_SERVICE" />
  </div>
</template>
